import { setDefaultOptions } from 'date-fns';

type DateFnsConfig = Parameters<typeof setDefaultOptions>[number];
export const dateFnsDefaultConfig: DateFnsConfig = {
  weekStartsOn: 1,
  firstWeekContainsDate: 7,
};
